import { useState } from "react";
import { api } from "../api.ts";

export function EventTranscript(props: { eventId: string }): React.JSX.Element {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState<{ transcript: string | null; artifactId: string | null; sourceAvailable: boolean }>();
  const [err, setErr] = useState("");
  const show = async (): Promise<void> => {
    if (open) { setOpen(false); return; }
    setOpen(true); setErr("");
    if (data) return;
    try { setData(await api.get<NonNullable<typeof data>>(`/api/events/${props.eventId}`)); }
    catch (e) { setErr((e as Error).message); }
  };
  return <div style={{ marginTop: 8 }}>
    <button className="b sm q" onClick={() => void show()}>{open ? "收起转写" : "查看转写与原始材料"}</button>
    {open && <div className="hint">
      {err && <p className="err">{err}</p>}
      {!data && !err && <p>加载转写…</p>}
      {data && <>
        {data.sourceAvailable && data.artifactId ? <a href={`/api/artifacts/${data.artifactId}/source`} target="_blank" rel="noreferrer">打开原始材料</a>
          : <p className="muted">原始材料已清理或未保留,转写与引用仍可查看。</p>}
        <p style={{ whiteSpace: "pre-wrap", maxHeight: 400, overflow: "auto" }}>{data.transcript ?? "没有转写文本"}</p>
      </>}
    </div>}
  </div>;
}
